module.exports = __webpack_public_path__ + "static/media/measurement_popup_img.51de4200.svg";